import { Component } from '@angular/core';

@Component({
  selector: 'wfp-accessibility-statement',
  templateUrl: './accessibility-statement.component.html',
  styleUrls: ['./accessibility-statement.component.scss'],
  standalone: false
})
export class AccessibilityStatementComponent {}
